
export default class NavAccordion {
	constructor(el) {
		this.element 	= el
		// TURNING THIS INTO AN ARRAY ENABLES US TO INDEX THROUGH IT
		this.accordions = [...document.querySelectorAll(".menu-item-has-children > a") ];
		// THIS BINDS THE CLICKACCORDION METHOD TO THE "THIS" CONTEXT
		this.clickAccordion = this.clickAccordion.bind(this)

		for (var i = 0; i < this.accordions.length; i++) {
			// console.log(this.accordions[i])
			this.accordions[i].addEventListener('click', this.clickAccordion )

			// SET DEFAULTS
			const accordion = this.accordions[i].parentNode
			const accordionButton = this.accordions[i]
			const accordionRegion = this.accordions[i].parentNode.querySelector(".sub-menu")
			accordionButton.setAttribute('role', 'button');
			accordionRegion.setAttribute('role', 'region');

			if( accordion.classList.contains('current_page_item') ){
				accordion.classList.add('accordion--open');
				accordionButton.setAttribute('aria-expanded', 'true');
				accordionRegion.setAttribute('aria-expanded', 'true');
			} else {
				accordion.classList.remove('accordion--open');
				accordionButton.setAttribute('aria-expanded', 'false');
				accordionRegion.setAttribute('aria-expanded', 'false');
			}
		}
	}
  
	clickAccordion(event) {
		event.preventDefault();

		const inx = this.accordions.indexOf(event.currentTarget)
		const accordion = this.accordions[inx].parentNode
		const accordionButton = this.accordions[inx]
		const accordionRegion = this.accordions[inx].parentNode.querySelector(".sub-menu")

		if( accordionButton.ariaExpanded === 'false' ){
			accordion.classList.add('accordion--open');
			if(window.innerWidth < 1239) {
				accordion.parentElement.classList.remove('accordion--reset');
			}
			accordionButton.setAttribute('aria-expanded', 'true');
			accordionRegion.setAttribute('aria-expanded', 'true');
		} else {
			accordion.classList.remove('accordion--open');
			if(window.innerWidth < 1239) {
				accordion.parentElement.classList.add('accordion--reset');
			}
			accordionButton.setAttribute('aria-expanded', 'false');
			accordionRegion.setAttribute('aria-expanded', 'false');
		}

		// IF THIS IS THE ALTERNATIVE ACCORDION TYPE, CLOSE SIBLINGS
		// this.closeSiblingAccordions(accordion,this.accordions);
	}

	changeAccordionAttributes(accordion){
		const accordionButton = accordion;
		const accordionRegion = accordion.parentNode.querySelector(".sub-menu");

		// CHANGE ATTR
		accordionButton.setAttribute('aria-expanded', 'false');
		accordionRegion.setAttribute('aria-expanded', 'false');
	}

	closeSiblingAccordions(exceptThis,siblings) {
		for (var i = 0; i < siblings.length; i++) {
			if (siblings[i] !== exceptThis) {
				siblings[i].parentNode.classList.remove('accordion--open');
				this.changeAccordionAttributes(siblings[i]);
			}
		}
	}
}